export default {
  errorNotAnImage: 'Náhľad nie je možný, súbor nie je obrázok alebo už nie je dostupný.',
};
